import React from "react";
import PropTypes from "prop-types";

import FormFeedback from "reactstrap/lib/FormFeedback";
import { gatherClasses } from "../../lib/utils";

const InputFeedback = props => {
  const { dataTestId, isValid, show, message } = props;
  return (
    <FormFeedback
      data-testid={dataTestId}
      valid={isValid}
      className={gatherClasses(props, show ? "oui-d-block" : null)}
    >
      {message}
    </FormFeedback>
  );
};

InputFeedback.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  isValid: PropTypes.bool,
  dataTestId: PropTypes.string
};

InputFeedback.defaultProps = {
  isValid: false,
  show: false,
  dataTestId: "orion-input-feedback"
};

InputFeedback.displayName = "OrionInputFeedback";

export default InputFeedback;
